import { AnwesenheitService } from "../_services/anwesenheit.service";
import { Fehlzeiten } from "./fehlzeiten";
//import { Kurs } from "./kurs";
//import { nearer } from "q";
//import { retry } from "rxjs/operator/retry";
//import { concat } from "rxjs/operator/concat";
//import { forEach } from "@angular/router/src/utils/collection";

export class Kursteilnehmer
{
  constructor(private aService: AnwesenheitService)
  {
    this.fehlzeiten = new Array<Fehlzeiten>();
  }
  email: string;
  kursteilnehmerNr: number;
  vorname: string;
  nachname: string;
  fehlzeiten: Fehlzeiten[];
  anwesend: boolean = true;
  kursNr: number;
  anrede: string;
  fehltage: number;
  fehlstunden: number;

  get Fehltage(): number {
    if (this.fehltage)
      return this.fehltage;
  }

  get Fehlstunden(): number {
    if (this.fehlstunden)
      return this.fehlstunden;
    let fz: string;
    this.aService.GetAbsenceTimeSpanUnexcused(this.kursteilnehmerNr).subscribe(
      timespan => fz = timespan,
      err => console.log(err),
      () => console.log(fz)
    );
  }

  static hatGanzTagFehlzeit(tn: Kursteilnehmer): boolean
  { 
    let b: boolean=false;
    tn.fehlzeiten.forEach(x =>
    {
      if (x.von.substr(0, 5) == "08:15" && x.bis.substr(0, 5) == "16:30")
      {
        b = true;
        //console.log("Ganztag: ");
        //console.log(tn);
      }
    });
    return b;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/teilnehmer.ts